import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alert.module';
import { account } from './account.module';
import { sites } from './sites.module';
import { users } from './users.module';
import { engines } from './engines.module';
import { revisions } from './revisions.module';
import { offline } from './offline.module';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        alert,
        account,
        sites,
        users,
        engines,
        revisions,
        offline
    }
});
